import React from "react";
import Link from "../../../../utils/Link";

export default function Logo() {
  return (
    <Link
      to="/"
      className="header-wrapper__logo header-wrapper__logo--corporate"
    >
      <img
        src="/images/shmlogo-blue-2.png"
        className="header-wrapper__logo-element"
        alt="Shkolla e Magjistraturës"
      />
      <img
        src="/images/shmlogo-white.png"
        className="header-wrapper__logo-element header-wrapper__logo-element--alt"
        alt="Shkolla e Magjistraturës"
      />
      <strong className="sr">Shkolla e Magjistraturës</strong>
    </Link>
  );
}
